import { API_ROUTES } from "../apiRoutes";
import { HttpClient } from "../HttpClient";
import { REQUEST_METHODS } from "../configs.apiClient";
import { StaticPages } from "@/types/staticPages.types";
import { captureError } from "@/utils/common.helpers";

export class StaticAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getStaticPages({ dialect, lang }: { dialect: string; lang: string }) {
    try {
      const method = REQUEST_METHODS.GET;
      const endpoint = API_ROUTES.static.pages;

      const response = await this.httpClient.request<StaticPages>({
        endpoint,
        options: {
          method,
        },
        addToken: false,
        dialect,
        lang: lang,
      });
      return response.data;
    } catch (error) {
      console.error("Error in getStaticPages", error);
      throw captureError(error);
    }
  }
}
